import ProvisionForm from './template';

export default ProvisionForm;
